//scss color vars for React

const grey = "#444";
const lightgrey = "#f5f5f5";
const orange = "#f47d20";
const brgreen = "#66ac47";
const uvmgreen = "#007155";
const watercourse = "#007155";
const ltgreen = "#a7d233";
const limegreen = "#D2E97C";
const newlimegreen = "#b2d23e";
const dkgreen = "#01533f";
const skyblue = "#a7d4ee";
const midblue = "#90d4ed";
const darkblue = "#159fda";
const bryellow = "#ffd416";
const yellowochre = "#d99b13";
const midgrey888 = "#888";
const yellow = "#ffd416";
const grayLight = "#ebebeb";
const grayLightmedium = "#cecece";
const grayMedium = "#7f7e7e";
const grayDark = "#444444";
const white = "#fff";
const black = "#000";
const dimGray = "#666";
const lightGreen = "#BFDF4B";
const darkGreen = "#007155";
export {
  grey,
  lightgrey,
  orange,
  brgreen,
  uvmgreen,
  watercourse,
  ltgreen,
  lightGreen,
  darkGreen,
  limegreen,
  newlimegreen,
  dkgreen,
  skyblue,
  midblue,
  darkblue,
  bryellow,
  yellowochre,
  midgrey888,
  yellow,
  grayLight,
  grayLightmedium,
  grayMedium,
  grayDark,
  white,
  black,
  dimGray,
};
export default {
  grey,
  lightgrey,
  orange,
  brgreen,
  uvmgreen,
  watercourse,
  ltgreen,
  lightGreen,
  darkGreen,
  limegreen,
  newlimegreen,
  dkgreen,
  skyblue,
  midblue,
  darkblue,
  bryellow,
  yellowochre,
  midgrey888,
  yellow,
  grayLight,
  grayLightmedium,
  grayMedium,
  grayDark,
  white,
  black,
  dimGray,
};
